import styled from 'styled-components';
import PartnersLogo from '../../assets/onboarding/myPartner-logo.svg';

const PartnerLogo = styled(PartnersLogo as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '13rem'};
height: ${props => props.height || '4.7rem'};
display: flex;
`;

export default PartnerLogo;
